import { Component, ErrorHandler, Inject, Input, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core'

import { KayttajaService } from 'app/_angular/service/kayttaja.service'
import { TunnistautuminenService } from 'app/_angular/service/tunnistautuminen.service'

import { ActionAfterAuthenticationLemonaid, AloitaTunnistautuminenJaAnnaUrlRequest, AloitaTunnistautuminenJaAnnaUrlResponse, InGroupeAuthMethod } from '@lemon/core-firebase/model/tunnistaminen'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'

import { Kayttaja } from '@lemon/core-firebase/model/kayttaja'
import { TuettuKieli } from '@lemon/core/model/common'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { environment } from 'environments/environment'

@Component({
  selector: '[tunnistautuminen-nets-pankit]',
  templateUrl: './pankit.component.html',
  styleUrls: ['./pankit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TunnistautuminenNetsPankitComponent implements OnInit {
  @Input() actionAfterSuccess: ActionAfterAuthenticationLemonaid
  @Input() kieli: TuettuKieli

  private _kayttajaPromise: Promise<Kayttaja> = null

  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _kirjautunutKayttajaService: KayttajaService,
    protected _ladataanService: LadataanService,
    private _errorHandler: ErrorHandler,
    protected _tunnistautuminenService: TunnistautuminenService,
    protected _firebaseLemonaid: FirebaseLemonaid,
  ) {
    this._kayttajaPromise = this._kirjautunutKayttajaService.getKayttaja()
  }

  ngOnInit() {}

  protected async _aloitaTunnistautuminenJaAnnaUrl(authMethod: InGroupeAuthMethod): Promise<AloitaTunnistautuminenJaAnnaUrlResponse> {
    const request: AloitaTunnistautuminenJaAnnaUrlRequest = {
      action: this.actionAfterSuccess,
      authMethod,
      kieli: this.kieli || 'fi',
      env: this._tunnistautuminenService.getNetsEnvironment(environment.environment),
    }
    return this._firebaseLemonaid.functionsCall<AloitaTunnistautuminenJaAnnaUrlRequest, AloitaTunnistautuminenJaAnnaUrlResponse>('tunnistautuminenNetsAloitaJaAnnaUrl', request)
  }

  private async _tunnistaudu(authMethod: InGroupeAuthMethod): Promise<void> {
    this._ladataanService.aloitaLataaminen()
    try {
      const [response, kayttaja] = await Promise.all([this._aloitaTunnistautuminenJaAnnaUrl(authMethod), this._kayttajaPromise])

      try {
        await this._tunnistautuminenService.startClientSideAuthenticationSession(this.actionAfterSuccess, response.avain, response.state)
      } catch (e) {
        this._errorHandler.handleError(new Error('Tunnistautumisen aloittaminen epäonnistui - session storageen kirjoittaminen epäonnistui!'))
        throw e
      }

      this._document.location.href = response.url
    } catch (e) {
      this._errorHandler.handleError(e)
      this._ladataanService.lopetaLataaminen()
    }
  }

  async tunnistauduMobiilivarmenne() {
    await this._tunnistaudu('fi_mobiilivarmenne')
  }

  async tunnistauduOp() {
    await this._tunnistaudu('opbank')
  }

  async tunnistauduNordea() {
    await this._tunnistaudu('nordea')
  }

  async tunnistauduDanske() {
    await this._tunnistaudu('danske')
  }

  async tunnistauduHandels() {
    await this._tunnistaudu('handelsbanken')
  }

  async tunnistauduAlands() {
    await this._tunnistaudu('aland')
  }

  async tunnistauduS() {
    await this._tunnistaudu('sbank')
  }

  async tunnistauduAktia() {
    await this._tunnistaudu('aktia')
  }

  async tunnistauduPop() {
    await this._tunnistaudu('popbank')
  }

  async tunnistauduSaasto() {
    await this._tunnistaudu('savingsbank')
  }

  async tunnistauduOmaSaasto() {
    await this._tunnistaudu('omasp')
  }
}
